import React from 'react'
import { ChatMessage } from '../../actions/agentQueryActions'

interface Props {
  message: ChatMessage
}

const bubbleStyle = (role: ChatMessage['role']): React.CSSProperties => {
  if (role === 'user') {
    return {
      alignSelf: 'flex-end',
      backgroundColor: '#0d6efd',
      color: '#fff',
      borderRadius: '18px 18px 4px 18px',
    }
  }
  if (role === 'error') {
    return {
      alignSelf: 'flex-start',
      backgroundColor: '#fff0f0',
      color: '#dc3545',
      borderRadius: '18px 18px 18px 4px',
    }
  }
  return {
    alignSelf: 'flex-start',
    backgroundColor: '#f0f0f0',
    color: '#212529',
    borderRadius: '18px 18px 18px 4px',
  }
}

const ChatBubble: React.FC<Props> = ({ message }) => (
  <div
    style={{
      ...bubbleStyle(message.role),
      maxWidth: '70%',
      padding: '8px 14px',
      marginBottom: '6px',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    }}
  >
    {message.text}
  </div>
)

export default ChatBubble
